import FigurePageIndex from "../../components/Figure/FigurePageIndex";
import api from "../../lib/api";

export default function Index({ figures, pagesData }) {
  const header = pagesData.find((page) => page.slug === "figures").header;
  return <FigurePageIndex figures={figures} header={header} />;
}

export async function getStaticProps({ locale }) {
  const data = await api.getContent("/api/collections/map-persons/entries", {
    fields: ["images"],
    sort: "title",
  });

  return await api.injectDefaultData(
    {
      props: {
        figures: data,
      },
      revalidate: 3,
    },
    locale,
  );
}
